var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneHangup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M635.389 293.649L582.66 377.894C575.03 390.098 559.569 395.246 546.03 389.875L440.623 347.775C428.17 342.85 420.486 330.125 421.91 316.902L428.551 250.433C358.33 226.49 281.764 226.479 211.574 250.412L218.196 316.922C219.533 330.188 211.916 342.786 199.525 347.775L94.044 389.907C80.441 395.214 65.001 390.151 57.327 377.862L4.619 293.638C-2.862 281.751 -1.118 266.468 8.849 256.514C180.427 85.159 459.581 85.168 631.138 256.504C641.117 266.468 642.86 281.751 635.389 293.649Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneHangup);
export default __webpack_public_path__ + "static/media/phone-hangup.af1ebd72be26d165326e65dff36e1a27.svg";
export { ForwardRef as ReactComponent };